import React, { FC } from 'react';
import { Modal } from '@mui/material';
import { FilterHeader20 } from '../../base/FilterHeader20';
import { Person } from '../../VisitReportPage/Person';
import './styled.scss';
import {BlackButton} from '../../HomePage/BlackButton';
import { useTranslation } from '../../../hooks/useTranslation';

interface IUpdateAddedPersonNotification {
    formik: any
    isVisible: boolean,
    setIsVisible: () => void;
    salutations: string[]
    addressesTypes: string[]
}

export const UpdateAddedPersonNotification:
    FC<IUpdateAddedPersonNotification> = ({
                                               isVisible,
                                               setIsVisible,
                                               formik,
                                               salutations,
                                               addressesTypes }) => {
    const { p: pNotif } = useTranslation('notifications');
    return(
        <Modal
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
            open={isVisible}>
            <div className="update-added-person-notification__modal">
                <FilterHeader20 title={pNotif('added_new_contact')} onClose={setIsVisible} />
                <div className='update-added-person-notification__modal__body'>
                    {(formik.values.new_persons || []).map((_: any, index: number) => (
                        <Person
                            key={index}
                            formik={formik}
                            personIndex={index}
                            salutations={salutations}
                            addressesTypes={addressesTypes}
                        />
                    ))}
                </div>
                <div className='update-added-person-notification__modal__footer'>
                    <div className="update-added-person-notification__modal__button_wrapper">
                        <BlackButton title={'Save changed'} onClick={formik.handleSubmit} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}